module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMDAgMTAwIiB3aWR0aD0iMTAwIiBoZWlnaHQ9IjEwMCI+PHBhdGggZD0iTTczLjg4IDY0Ljk0Yy01IDAtMTQuODUgMS4yNC0yMi45MyAzLjM4LTIuNzItMTAuMTQtMTEuNzctMzEuNzktMTkuMTQtMzcuODRoLS4wMWMtLjE3LS4xNC0uMzQtLjI4LS41MS0uNDEtNi4yNy01LjA1LTE1LjQ3LTMuNjEtMTQuMTIgMi4xOGw5LjE2IDM4LjE0Yy44NCA0LjggMy40NCA4LjEyIDQuNDkgOS42N2E5LjY5NSA5LjY5NSAwIDAgMCA4LjA0IDQuMjhoMzEuMTNjNS4zNiAwIDkuNy00LjM0IDkuNy05Ljd2LTMuODljLS4wMS0zLjIxLTIuNjEtNS44MS01LjgxLTUuODF6Ii8+PC9zdmc+"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/car-features/has_seat_for_child.svg
// module id = BPF2
// module chunks = 1